// react-redux imports
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { Waypoint } from "react-waypoint";

// common imports
import ScrollIndicator from "common/components/ScrollIndicator";

// styled-components imports
import Container from "./styled-components/Container";
import Description from "./styled-components/Description";
import Title from "./styled-components/Title";

interface FactorsProps {
  handleWaypoint: (section: 1 | 2) => (args: Waypoint.CallbackArgs) => void;
}

function Factors({ handleWaypoint }: FactorsProps) {
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  return (
    <Waypoint
      onPositionChange={handleWaypoint(2)}
      topOffset={upDesktopScreen ? 156 : 83}
      bottomOffset={upDesktopScreen ? 255 : 141}
    >
      <Container>
        <Title>Qué es</Title>
        <Description>
          La huella de carbono resulta del efecto directo o indirecto de las
          actividades económicas y cotidianas de un individuo, organización,
          evento o producto. Se representa en los Gases de efecto Invernadero y
          su resultado se mide en toneladas de CO<sub>2</sub>
        </Description>
        <ScrollIndicator description="¿Qué factores influyen en tu Huella de Carbono?" />
      </Container>
    </Waypoint>
  );
}

export default Factors;
